var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.955 47.68C47.605 48.79 48 50.065 48 51.44C48 55.58 44.645 58.94 40.5 58.94C36.355 58.94 33 55.58 33 51.44C33 47.3 36.355 43.94 40.5 43.94C40.875 43.94 41.23 43.995 41.59 44.05L61.74 18.885L63.39 19.92L46.955 47.68ZM40.5 20C43.72 20 46.81 20.535 49.72 21.485C49.94 21.555 52.22 21.955 53.08 20C53.895 18.145 52.215 17.025 51.52 16.79C48.05 15.635 44.355 15 40.5 15C21.17 15 5.5 30.67 5.5 50C5.5 53.235 5.975 56.355 6.8 59.33C6.8 59.33 8.24 61.535 10.425 60.405C12.23 59.465 11.635 58.15 11.48 57.55C10.84 55.135 10.5 52.61 10.5 50C10.5 33.455 23.955 20 40.5 20ZM65.19 29.14C63.705 30.625 64.84 32.53 64.975 32.73C68.44 37.62 70.5 43.57 70.5 50C70.5 52.85 70.09 55.605 69.35 58.215C69.24 58.59 69.355 60.57 70.97 60.895C73.425 61.395 74.2 59.335 74.2 59.335C75.025 56.355 75.5 53.235 75.5 50C75.5 42.31 73.02 35.205 68.81 29.44C68.355 28.815 66.29 28.035 65.19 29.14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/Icon7.1f9f196a377cfaa945332df6b828db27.svg";
export { ForwardRef as ReactComponent };